<footer>
    <ng-content />
    <nav>
        <ul>
            @for (item of footerItems; track item) {
                <li>
                    <a [routerLink]="item.link">{{ item.label | translate }}</a>
                </li>
            }
        </ul>
    </nav>
</footer>
